module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.codigo),
      expression: "dados.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "codigo",
      "maxlength": "2",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "codigo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('codigo')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subgrupo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.procedimento_subgrupo_id),
      expression: "dados.procedimento_subgrupo_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "subgrupo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "procedimento_subgrupo_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o subgrupo...")]), _vm._v(" "), _vm._l((_vm.subgrupos), function(subgrupo, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": subgrupo.id
      }
    }, [_vm._v(_vm._s(subgrupo.codigo) + " - " + _vm._s(subgrupo.nome))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('subgrupo')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4d8e1ca2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastros/procedimentos/formas_organizacao/form.vue
// module id = 844
// module chunks = 0